<template>
  <div>
    <v-container class="grey lighten-5">
      <v-row no-gutters class="pagination-table-header">
        <v-col
          col="12"
        >
          <v-overlay
            :absolute="true"
            :value="isComponentLoading"
          >
            <v-progress-circular indeterminate size="24"></v-progress-circular>
          </v-overlay>
          <v-card
            v-if="L.isEmpty(paginatedObject) || L.isEmpty(paginatedObject.data)"
            class="pa-3">
            <p class="text-center mt-2">
              <v-icon>mdi-account-search-outline</v-icon>
              <b>&nbsp;&nbsp;{{lang($store, 'sap/listings.managers.not_found')}}&nbsp;&nbsp;</b>
              <v-icon>mdi-account-badge-outline</v-icon>
            </p>
          </v-card>
          <div v-else>
            <v-card
              v-for="(item, key) in paginatedObject.data"
              :key="key"
              :color="rolesColors[item.role]"
              class="mx-auto pa-2 mb-2"
              outlined
            >
              <v-list-item
                :style="{
                  opacity: (!item.active)?0.5:1,
                }"
              >
                <v-list-item-content class="white--text">
                  <div class="overline mb-4">
                    <v-chip
                      v-if="!item.active"
                      class="mr-2 mb-2"
                      color="grey lighten-1"
                      outlined
                      text-color="grey lighten-1"
                    >
                      {{lang($store, 'sap/listings.global.not_active')}}
                    </v-chip>
                    <div class="d-block d-sm-inline-block">
                      {{$t('enums.roles.'+ item.role)}}
                    </div>
                  </div>
                  <v-list-item-title class="headline mb-1">{{item.name}}
                    <div class="d-block d-sm-inline-block ml-0 ml-sm-2">
                      <a :href="'tel:' + item.phone">
                        <v-chip
                          class="my-2"
                          style="cursor: pointer"
                          color="white"
                          outlined
                          text-color="white"
                        >
                          <v-avatar left>
                            <v-icon>mdi-cellphone</v-icon>
                          </v-avatar>
                          {{item.phone}}
                        </v-chip>
                      </a>
                    </div>
                  </v-list-item-title>
                  <v-list-item-subtitle class="white--text">
                    {{item.note}}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-card-actions v-if="account.role === MANAGER_TOP || account.role === MANAGER_SERVICE">
                <v-btn text icon color="grey lighten-2"
                       @click="onItemEdit(item)"
                >
                  <v-icon>mdi-account-edit-outline</v-icon>
                </v-btn>
                <v-btn text icon color="grey lighten-2"
                       @click="onItemDelete(item)"
                >
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </v-container>

  </div>
</template>

<script>
import _ from 'lodash';
/* constants */
import { MANAGER_TOP, MANAGER_SERVICE } from '@/constants/roles';
/* utils */
import { roles as rolesColors } from '../../utils/listingColors';
/* mixins */
import isComponentLoading from '../../mixins/isComponentLoading';

export default {
  name: 'TablePaginatedManagers',
  mixins: [isComponentLoading],
  data() {
    return {
      MANAGER_TOP,
      MANAGER_SERVICE,
      rolesColors,
      L: _,
    };
  },
  props: {
    paginatedObject: {
      type: Object,
      default: () => {
      },
    },
    noActions: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    account() {
      return this.$store.getters['account/account'];
    },
  },
  methods: {
    onItemEdit(item) {
      this.$emit('edit-item', item);
    },
    onItemDelete(item) {
      this.$emit('delete-item', item);
    },
  },
};
</script>

<style lang="sass" scoped>
  .table-action
    &:hover
      fill: #0066ff
      transition: fill 0.5s
      cursor: pointer
</style>
